interface InputFieldColors {
  background?: string | null;
  border?: string | null;
  text?: string | null;
  error?: string | null;
}
interface InputFieldStyle {
  font?: string | null;
  cornerRadius?: number | null;
  borderWidth?: number | null;
  padding?: number | null;
}
export interface InputFields {
  colors?: InputFieldColors | null;
  style?: InputFieldStyle | null;
}

const INPUT_WRAPPER_SELECTOR = "label.bg-color-primary:has(input)";

export function buildInputFieldRules(
  s: string,
  inputFields: InputFields | null | undefined,
): string[] {
  if (!inputFields) return [];
  const colors = inputFields.colors ?? undefined;
  const style = inputFields.style ?? undefined;

  const background = colors?.background || undefined;
  const border = colors?.border || undefined;
  const text = colors?.text || undefined;

  const wrapperProps: string[] = [];
  if (background) {
    // `!important` beats the inline background on the readonly-branch label.
    wrapperProps.push(`background-color: ${background} !important;`);
  }
  if (border) {
    wrapperProps.push(`border-color: ${border} !important;`);
  }
  if (typeof style?.cornerRadius === "number") {
    wrapperProps.push(`border-radius: ${style.cornerRadius}px;`);
  }
  if (typeof style?.borderWidth === "number") {
    wrapperProps.push(`border-width: ${style.borderWidth}px;`);
  }
  if (typeof style?.padding === "number") {
    wrapperProps.push(`padding: ${style.padding}px;`);
  }
  if (style?.font) {
    wrapperProps.push(`font-family: ${style.font};`);
  }

  const rules: string[] = [];
  if (wrapperProps.length > 0) {
    rules.push(`${s}${INPUT_WRAPPER_SELECTOR} { ${wrapperProps.join(" ")} }`);
  }
  // Override the design-system's focus-within border swap.
  if (border) {
    rules.push(
      `${s}${INPUT_WRAPPER_SELECTOR}:focus-within { border-color: ${border} !important; }`,
    );
  }
  // Target the `<input>` directly so the merchant's color beats the primary
  // text token inherited from the wrapping label.
  if (text) {
    rules.push(
      `${s}${INPUT_WRAPPER_SELECTOR} input { color: ${text} !important; }`,
    );
  }

  return rules;
}
